export enum ChatView {
  MAIN = "main",
  SUMMARY = "summary",
  SECURITY_GAPS_SUMMARY = "securityGapsSummary",
  ASK = "ask",
  CHAT = "chat",
}

export enum FeedbackRating {
  HELPFUL = "helpful",
  UNHELPFUL = "unhelpful",
}

export enum ToolApprovalStatus {
  PENDING = "PENDING",
  EXECUTED = "EXECUTED",
  REJECTED = "REJECTED",
  FAILED = "FAILED",
  PERMISSION_DENIED = "PERMISSION_DENIED",
}

export enum ToolApprovalType {
  UNIGNORE_SECURITY_GAP = "unignoreSecurityGap",
  IGNORE_SECURITY_GAP = "ignoreSecurityGap",
  FIX_SECURITY_GAP = "fixSecurityGap",
  DO_EVENT_ACTION = "doEventAction",
}
